module.exports = __webpack_public_path__ + "img/ojo-abierto.40fcbb9c.svg";